/* eslint-disable react/no-unescaped-entities */
import React from 'react';

const Experience = () => {
  return (
    <section id="experience">
      <h5>Experience</h5>
      <h2>My Experience</h2>
      <div className="container experience__container">
        <div className="experience__one">
          <h2>ELMAN SIIVOUS OY</h2>
          <h3>2019-</h3>
          <p>Finance Manager</p>
          <p className>
            Coding currently a booking system for the client side interaction.
            Booking app estimatedly ready by end of Janury 2023. Responsible for
            managing the company's overall operations. Delegating and directing
            agendas, staff recruitment, managing company organizational
            structure, leading the development of companys short and long term
            strategy. I am very familiar in client relations regarding
            governement projects and subcon protocols with big companies.
            driving profitability and keeping the revenue stable during this
            pandemic, has been my greatest success with my team as the revenue
            increased 50% during 2018-2020.
          </p>
        </div>
        <p />
      </div>
    </section>
  );
};

export default Experience;
